<script>
import CoreComponent from "../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue";

export default {
  extends: CoreComponent,
  mounted() {

    let prElements = {
    prnews_span: this.cmpEl.querySelectorAll(".prnews_span"),
    prnews_a: this.cmpEl.querySelectorAll(".prnews_a"),
    prnews_li: this.cmpEl.querySelectorAll(".prnews_li"),
    prnews_p: this.cmpEl.querySelectorAll(".prnews_p")
    }

    prElements.prnews_a.forEach(link => {
      link.style.background = "none";
    })

    for (let prClass in prElements) {
    prElements[prClass].forEach(element => {
        element.classList.remove(prClass);
    })
    }
  }
};
</script>

<style lang="scss">
@import "./press-release.scss";
</style>
